import { query, customElement, property } from 'lit/decorators.js';
import { LitElement, html, TemplateResult, PropertyValues } from 'lit';
import { styles } from '../view/style';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { API_TYPE_GZ, WEB_COMPONENT_PATCHES_DETAILS_PANEL } from '../../../../../../../../webcomponents.constants';
import { getTimezone } from '../../../../../../../../utils/global.utils';
import { CveGridWebComponent } from '../../cveGrid';
import { ProductsGridWebComponent } from '../../productsGrid';

@customElement(WEB_COMPONENT_PATCHES_DETAILS_PANEL)
export class PatchDetailsWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  @property({ type: String, reflect: true })
  public patchId: string;

  @property({ type: Number, reflect: true })
  public productsCount: number;

  @query('gz-patch-details-cve-grid')
  private cveGrid: CveGridWebComponent;

  @query('gz-patch-details-products-grid')
  private productsGrid: ProductsGridWebComponent;

  protected firstUpdated(changedProps: PropertyValues) {
    super.firstUpdated(changedProps);

    this.buildCveGrid();
    this.buildProductsGrid();
  }

  private buildCveGrid() {
    if (!this.cveGrid) {
      return;
    }

    this.cveGrid.patchId = this.patchId;
    this.cveGrid.injectDependencies({ api: { type: API_TYPE_GZ }, translateFn: translateFn, getTimezone: getTimezone });
    this.cveGrid.start().catch(console.error);
  }

  private buildProductsGrid() {
    if (!this.productsGrid) {
      return;
    }

    this.productsGrid.patchId = this.patchId;
    this.productsGrid.productsCount = this.productsCount;
    this.productsGrid.injectDependencies({
      api: { type: API_TYPE_GZ },
      translateFn: translateFn,
      getTimezone: getTimezone,
    });
    this.productsGrid.start().catch(console.error);
  }

  protected render(): TemplateResult {
    return html` <div class="wrapper">
      <gz-title fontSize="16" fontWeight="500" class="title">${translateFn('Patch details')}</gz-title>
      <gz-tab-group>
        <gz-tab id="cveListTab" label="${translateFn('CVE')}">
          <gz-patch-details-cve-grid></gz-patch-details-cve-grid>
        </gz-tab>
        <gz-tab id="productsListTab" label="${translateFn('PRODUCTS')}">
          <gz-patch-details-products-grid></gz-patch-details-products-grid>
        </gz-tab>
      </gz-tab-group>
    </div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-patches-details-panel': PatchDetailsWebComponent;
  }
}
